import React, { useCallback, useState } from "react";
import { Button, InputField } from "@/components";
import { FaArrowRight } from "react-icons/fa6";

const ChannelForm = ({
  AlertDialog,
  channelId,
  formFields: initialFormFields,
  onConnect = () => {},
  isUpdate = false,
  setOpen,
  handleViewGuide = () => {
    console.log("View Guide");
  },
}) => {
  const [formFields, setFormFields] = useState(initialFormFields);

  const handleChange = (fieldName, value) => {
    setFormFields(prevFields =>
      prevFields.map(field =>
        field.name === fieldName ? { ...field, value } : field
      )
    );
  };

  const handleConnect = (e) => {
    e.preventDefault();
    if (isUpdate) {
      setOpen(false);
      return;
    }
    console.log("Connecting channel:", channelId);
    // Collect form data
    const formData = formFields.reduce((acc, field) => {
      acc[field.name] = field.value;
      return acc;
    }, {});
    console.log("Form data:", formData);
    onConnect(channelId, formData, setOpen);
  };

  return (
    <div className="my-4">
      <form onSubmit={handleConnect} className="flex flex-col gap-4">
        {formFields.map((field) => (
          <InputField
            key={field.name}
            id={field.name}
            type={field.type}
            label={field.label}
            placeholder={field.placeholder}
            value={field.value || ""}
            onChange={(val) => handleChange(field.name, val)}
            disabled={isUpdate}
          />
        ))}

        <button
          type="button"
          onClick={handleViewGuide}
          className="flex justify-between items-center hover:opacity-80 gap-2 bg-secondary/10 cursor-pointer rounded-xl h-12 border-2 border-secondary/25 py-2 px-4"
        >
          <p className="text-body2 font-ptsans text-secondary/90 font-semibold">
            View Integration Guide
          </p>
          <FaArrowRight className="text-subtitle1 font-ptsans text-secondary/90" />
        </button>

        <div className="flex justify-end gap-2">
          <Button type="submit" variant="default" size="md" className="mt-4" >
            {isUpdate ? "Update" : "Connect"} <FaArrowRight className="pl-1" />
          </Button>
        </div>
      </form>
      <AlertDialog />
    </div>
  );
};

export default ChannelForm;
